<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un lot..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
  
          <div class="btn-group rounded-pill shadow-sm" style="margin-right:12px">
            <!-- Left side - Nouveau button -->
            <button class="btn btn-primary btn-sm rounded-start-pill" 
                    style="width: 70px;"
                    (click)="openModal(content)">
              <i class="fa-solid fa-plus" style="font-weight: bold;"></i>
            </button>
            
            <!-- Right side - Actions dropdown -->
            <div class="btn-group dropdown">
              <button type="button" class="btn btn-primary btn-sm rounded-end-pill dropdown-toggle" 
                      style="width: 70px; border-left: 1px solid rgba(255,255,255,0.3);"
                      data-bs-toggle="dropdown" aria-expanded="false">
                @if (loadingRapport || loadingCodeBarre) {
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                } @else {
                  <i class="fa-solid fa-ellipsis-vertical"></i> 
                }
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <div class="row d-flex justify-content-center" style="width: 210px">
                  <div class="col-lg-12">
                    <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2"
                            [disabled]="loadingRapport"
                            (click)="generateReportsForBatches()">
                      @if (loadingRapport) {
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="px-2">Chargement</span>
                      } @else {
                        <span><i class="fa-solid fa-file-pdf px-2"></i>Rapport</span>
                      }
                    </button>
                  </div>
                  <!-- lot.component.html -->


                  
                  <div class="col-lg-12">
                    <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2"
                            [disabled]="loadingCodeBarre"
                            (click)="generateCodeBarreForBatches()">
                      @if (loadingCodeBarre) {
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="px-2">Chargement</span>
                      } @else {
                        <span><i class="fa-solid fa-barcode px-2"></i>CodeBarre</span>
                      }
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
            <button class="btn btn-outline-primary btn-sm rounded-pill border-0" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-arrow-down-short-wide px-3"></i>
            </button>

        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
              
                  <!-- select Column -->
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="handleSelectAll()" [checked]="isAllRapportSelected"/>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-checkbox [checked]="isAllRapportSelected" (change)="handleSelection(element)"/>
                    </td>
                  </ng-container>
                
                  <!-- Nom du lot -->
                  <ng-container matColumnDef="batchName">
                    <th mat-header-cell *matHeaderCellDef> Référence du lot </th>                 
                    <td mat-cell *matCellDef="let element">
                       <a [routerLink]="['/sample-details', element.id]">{{ element.batchName }} </a>
                    </td>
                  </ng-container>


                
                  <!-- Type du lot -->
                  <ng-container matColumnDef="batchType">
                    <th mat-header-cell *matHeaderCellDef> Type du lot </th>
                    <td mat-cell *matCellDef="let element"> {{ element.batchType }} </td>
                  </ng-container>
                <ng-container matColumnDef="descriptif">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> {{ element.descriptif }} </td>
                  </ng-container>
                  <!-- Date de création -->
                  <ng-container matColumnDef="creationDate">
                    <th mat-header-cell *matHeaderCellDef> Date de création </th>
                    <td mat-cell *matCellDef="let element"> {{ element.creationDate | date }} </td>
                  </ng-container>
                
                  <!-- Statut -->
       
                  <!-- Client 
                  <ng-container matColumnDef="clientName">
                    <th mat-header-cell *matHeaderCellDef> Client </th>
                    <td mat-cell *matCellDef="let element">  {{ getClientName(element.clientId) }}  </td>
                  </ng-container>
                  -->
                  <ng-container matColumnDef="createdBy">
                    <th mat-header-cell *matHeaderCellDef> Créateur </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.createdByUsername || 'N/A' }}
                    </td>
                  </ng-container>
                  

                  <!-- Nombre d'échantillons -->
                  <ng-container matColumnDef="numberOfSamples">
                    <th mat-header-cell *matHeaderCellDef> Nombre d'échantillons </th>
                    <td mat-cell *matCellDef="let element"> {{ element.numberOfSamples }} </td>
                  </ng-container>
                 <ng-container matColumnDef="commentaire">
                    <th mat-header-cell *matHeaderCellDef>Commentaire </th>
                    <td mat-cell *matCellDef="let element"> {{ element.commentaire }} </td>
                  </ng-container>
                  <!-- Actions -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Actions </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="action-info text-center" style="justify-content: center !important;">
                        <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above" (click)="openEditModal(element, editModal)">
                          <i class="material-symbols-outlined text-primary">brush</i>
                        </button>
                        <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above" (click)="confirmDelete(element)">
                          <i class="material-symbols-outlined text-danger">delete</i>
                        </button>
             <!--          <button type="button" mat-button matTooltip="Générer le rapport PDF" matTooltipPosition="above"
                        (click)="downloadReport(element.id)">
                  <i class="fa-solid fa-file-pdf text-success"></i>
                      </button>
                      <button type="button" mat-button matTooltip="Générer le code barre PDF" matTooltipPosition="above"
                      (click)="downloadCodeBarre(element.id)">
                      <i class="fa-solid fa-barcode text-success"></i>
                    </button>--> 
                      </div>
                    </td>
                  </ng-container>
              
                  <!-- Table Header and Rows -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              
                </table>
                
                <div *ngIf="loadingTable">
                  <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                    <span class="skeleton-cell"></span>
                  </div>
                </div>
              </div>
              
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

        </div>

    </mat-card-content>

    <ng-template #content let-modal>
        <mat-card class="daxa-card border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mt-0 mb-0">Création d'un lot</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="Form" (ngSubmit)="saveBatch()">
              <div class="row g-3">
                <!-- Nom du lot -->
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Référence du Lot</mat-label>
                    <input matInput formControlName="batchName" placeholder="Référence du lot">
                    <mat-error *ngIf="Form.get('batchName')?.hasError('required')">La référence du lot est requis</mat-error>
                  </mat-form-field>
                </div>
    
                <!-- Client -->
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Client</mat-label>
                    <mat-select formControlName="clientId">
                      <mat-option *ngFor="let client of clientList" [value]="client.id">
                        {{ client.socialReason }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="Form.get('clientId')?.hasError('required')">Le client est requis</mat-error>
                  </mat-form-field>
                </div>
            
                <!-- Type du lot -->
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Type du Lot</mat-label>
                      <input matInput formControlName="batchType" placeholder="Type du lot">
                    <mat-error *ngIf="Form.get('batchType')?.hasError('required')">Le type du lot est requis</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Desciption</mat-label>
                      <input matInput formControlName="descriptif" placeholder="Description du lot">
                    <mat-error *ngIf="Form.get('descriptif')?.hasError('required')">Description du lot est requis</mat-error>
                  </mat-form-field>
                </div>
    
                <!-- Statut -->
              

                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Nombre d'échantillons</mat-label>
                    <input matInput type="number" formControlName="numberOfSamples" placeholder="Nombre d'échantillons">

                    <mat-error *ngIf="Form.get('numberOfSamples')?.hasError('required')">Le nombre d'échantillons est requis</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Commentaire</mat-label>
                      <input matInput formControlName="commentaire" placeholder="Commentaire sur le lot">
                  </mat-form-field>
                </div>
                <!-- Date de création 
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Date de création</mat-label>
                    <input matInput type="date" formControlName="creationDate">
                    <mat-error *ngIf="Form.get('creationDate')?.hasError('required')">La date de création est requise</mat-error>
                  </mat-form-field>
                </div>-->
    
                <!-- Bouton de soumission -->
                <div class="col-sm-12 text-right">
                  <button type="submit" class="btn btn-outline-success">Enregistrer</button>
              </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
    </ng-template>

    <ng-template #editModal let-modal>
        <mat-card class="daxa-card border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mt-0 mb-0">Modification du lot</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="Form" (ngSubmit)="updateBatch()">
              <div class="row g-3">
                <!-- Nom du lot -->
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Référence du Lot</mat-label>
                    <input matInput formControlName="batchName" placeholder="Référence du lot">
                    <mat-error *ngIf="Form.get('batchName')?.hasError('required')">Le référence du lot est requis</mat-error>
                  </mat-form-field>
                </div>
    
                <!-- Client -->
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Client</mat-label>
                    <mat-select formControlName="clientId">
                      <mat-option *ngFor="let client of clientList" [value]="client.id">
                        {{ client.socialReason }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="Form.get('clientId')?.hasError('required')">Le client est requis</mat-error>
                  </mat-form-field>
                </div>
            
                <!-- Type du lot -->
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Type du Lot</mat-label>
                    <input matInput formControlName="batchType">
                    <mat-error *ngIf="Form.get('batchType')?.hasError('required')">Le type du lot est requis</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Description</mat-label>
                    <input matInput formControlName="descriptif">
                    <mat-error *ngIf="Form.get('descriptif')?.hasError('required')">Description du lot est requis</mat-error>
                  </mat-form-field>
                </div>
                <!-- Statut -->
  
                <!-- Nombre d'échantillons -->
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Nombre d'échantillons</mat-label>
                    <input matInput type="number" formControlName="numberOfSamples" placeholder="Nombre d'échantillons">
                    <mat-error *ngIf="Form.get('numberOfSamples')?.hasError('required')">Le nombre est requis</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Commentaire</mat-label>
                    <input matInput formControlName="commentaire">
                  </mat-form-field>
                </div>
                <!-- Date de création 
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <mat-label>Date de création</mat-label>
                    <input matInput type="date" formControlName="creationDate">
                    <mat-error *ngIf="Form.get('creationDate')?.hasError('required')">La date est requise</mat-error>
                  </mat-form-field>
                </div>
    -->
                <!-- Bouton de soumission -->
                <div class="col-sm-12 text-right">
                  <button type="submit" class="btn btn-outline-success">Enregistrer</button>
              </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
    </ng-template>


<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
  <div class="scrollable-menu shadow-lg bg-body">
      <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                    (click)="$event.stopPropagation()">Tous
      </mat-checkbox>
      @for (col of columns; track $index) {
          <div>
              <mat-checkbox [value]="col"
                            [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                            (click)="$event.stopPropagation(); onSelectionChange(col)">
                  {{ col }}
              </mat-checkbox>
          </div>
      }
  </div>

</mat-menu>
    
</mat-card>

